import React, { useEffect, useState } from "react";
import { Outlet, NavLink, useNavigate, Link } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingCart, Ticket, Users, LogOut, ExternalLink, Settings } from "lucide-react";
import api from "../../lib/api";

const LINKS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/orders", label: "Orders", icon: ShoppingCart, badge: true },
  { to: "/admin/coupons", label: "Coupons", icon: Ticket },
  { to: "/admin/customers", label: "Customers", icon: Users },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);
  const [newOrders, setNewOrders] = useState(0);

  useEffect(() => {
    if (!localStorage.getItem("aadvan_admin_token")) { navigate("/admin/login"); return; }
    api.get("/auth/me").then(() => setReady(true)).catch(() => {
      localStorage.removeItem("aadvan_admin_token");
      navigate("/admin/login");
    });
  }, [navigate]);

  useEffect(() => {
    if (!ready) return;
    const fetchCount = () => api.get("/admin/orders/new-count").then((r) => setNewOrders(r.data.new_orders)).catch(() => {});
    fetchCount();
    const t = setInterval(fetchCount, 20000);
    return () => clearInterval(t);
  }, [ready]);

  const logout = () => {
    localStorage.removeItem("aadvan_admin_token");
    localStorage.removeItem("aadvan_admin_user");
    navigate("/admin/login");
  };

  if (!ready) return <div className="min-h-screen flex items-center justify-center bg-cream text-muted-foreground">Loading…</div>;

  return (
    <div className="min-h-screen flex bg-cream">
      <aside className="w-64 bg-forest text-cream flex flex-col fixed h-full">
        <div className="p-6 border-b border-cream/10">
          <div className="font-serif text-2xl text-gold">Aadvan</div>
          <div className="text-[10px] tracking-[0.3em] uppercase text-cream/50">Admin Console</div>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {LINKS.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.end} data-testid={`admin-nav-${l.label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 px-4 py-3 rounded-lg text-sm transition-colors ${isActive ? "bg-gold text-forest" : "text-cream/70 hover:bg-cream/10"}`}>
              <l.icon size={18} /> <span className="flex-1">{l.label}</span>
              {l.badge && newOrders > 0 && (
                <span data-testid="new-orders-badge" className="bg-gold text-forest text-[10px] font-semibold min-w-5 h-5 px-1.5 rounded-full flex items-center justify-center">{newOrders}</span>
              )}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-cream/10 space-y-1">
          <Link to="/" target="_blank" className="flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm text-cream/70 hover:bg-cream/10"><ExternalLink size={16} /> View Store</Link>
          <button onClick={logout} data-testid="admin-logout" className="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg text-sm text-cream/70 hover:bg-cream/10"><LogOut size={16} /> Logout</button>
        </div>
      </aside>
      <main className="flex-1 ml-64 p-8">
        <Outlet />
      </main>
    </div>
  );
}
